import React, { createRef } from "react";
import {
  Select,
  Table,
  Row,
  Col,
  Button,
  Space,
  DatePicker,
  Dropdown,
  Modal, Checkbox, Tooltip, Image,
  Divider
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";

import { DownOutlined } from "@ant-design/icons";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import withRouter from "../withRouter";

import VehicleStore from "../store/VehicleStore";

import dayjs from "dayjs";
import { decode as base64_decode } from "base-64";
import Cookies from "js-cookie";

import DriverLoginReportStore from "../store/DriverLoginReportStore";
import TripLogReportStore from "../store/TripLogReportStore";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import XML from "../assets/images/NewDesign/XML.svg";
import CSV from "../assets/images/NewDesign/CSV.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import PythonMessageAlert from "./PythonMessageAlert";
const { RangePicker } = DatePicker;

const { Option } = Select;

let widthAdderFunc = (arr) => {
  let array = arr;
  array.map((val) => {
    if (val.title?.length > 24) {
      val.width = 250;
    } else if (val.title?.length > 15) {
      val.width = 200;
    } else if (val.title?.length > 12) {
      val.width = 150;
    } else if (val.title?.length > 8) {
      val.width = 125;
    } else {
      val.width = 110;
    }
  });

  return arr;
};
class TripLogReport extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.vehicleStore = new VehicleStore();
    this.tripLogReportStore = new TripLogReportStore(this);
    this.driverLoginStore = new DriverLoginReportStore(this);
    this.pythonMessageRef = createRef();

    this.ExportOption = [
      {
        label: (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            {" "}
            <Image
              style={{ height: "18px", width: "18px", borderRadius: "0px" }}
              src={Excel}
            ></Image>
            {context.translate("_EXPORT_AS_EXCEL_")}
          </div>
        ),
        key: "excel",
      },
      {
        label: (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            {" "}
            <Image
              style={{ height: "18px", width: "18px", borderRadius: "0px" }}
              src={PDF}
            ></Image>
            {context.translate("_EXPORT_AS_PDF_")}
          </div>
        ),
        key: "pdf",
      }
    ];
    this.innerColumns = widthAdderFunc([
      {
        title: context.translate("_BOOKING_COMPANY_"),
        dataIndex: "companyName",
        key: "companyName",
        width: "10%",
      },
      {
        title: context.translate("_VEHICLE_NO_"),
        dataIndex: "vehicleNo",
        key: "vehicleNo",
        width: "10%",
      },
      {
        title: context.translate("_NO_OF_PASSENGERS_"),
        dataIndex: "noOfPassenger",
        key: "noOfPassenger",
        width: "10%",
      },
      {
        title: context.translate("_FLEET_VEHICLE_VEHICLELIST_DRIVER_"),
        dataIndex: "driverName",
        key: "driverName",
        width: "10%",
      },
      {
        title: context.translate("_ORDER_CHANNEL_"),
        dataIndex: "orderChannelId",
        key: "orderChannelId",
        width: "10%",
        render: (value, record) => {
          debugger;
          switch (parseInt(record.orderChannelId, 10)) {
            case 1:
              return "App";
            case 2:
              return "Local";
            case 3:
              return "Call Center";
            default:
              return "App";
          }
        },
      },
      {
        title: context.translate("_PAYMENT_TYPE_"),
        dataIndex: "paymentMethod",
        key: "paymentMethod",
        width: "10%",
        render: (value, record) => {
          switch (record.paymentMethod) {
            case 1:
              return "Cash";
            case 2:
              return "Card";
            case 3:
              return "QRIS";
            default:
              return "Cash";
          }
        },
      },
      {
        title: context.translate("_FARE_TYPE_"),
        dataIndex: "selectedFareType",
        key: "selectedFareType",
        width: "10%",
        render: (value, record) => {
          switch (record.selectedFareType) {
            case 1:
              return "Fixed";
            case 2:
              return "Estimated";
            default:
              return "Estimated";
          }
        },
      },
      {
        title: context.translate("_TRIP_TYPE_"),
        dataIndex: "tripType",
        key: "tripType",
        width: "10%",
      },
      {
        title: context.translate("_TRIP_TYPE_DESCRIPTION_"),
        dataIndex: "tripTypeDesc",
        key: "tripTypeDesc",
        width: "10%",
      },
      {
        title: context.translate("_PICKUP_TIME_"),
        dataIndex: "tripStartTime",
        key: "tripStartTime",
        width: "10%",
      },
      {
        title: context.translate("_PICKUP_LOCATION_"),
        dataIndex: "pickupAddress",
        key: "pickupAddress",
        width: "10%",
      },

      {
        title: context.translate("_DROP_TIME_"),
        dataIndex: "tripEndTime",
        key: "tripEndTime",
        width: "10%",
      },
      {
        title: context.translate("_DROP_LOCATION_"),
        dataIndex: "dropAddress",
        key: "dropAddress",
        width: "10%",
      },
      {
        title: context.translate(
          "_FLEET_RULEDETAIL_SELECTPARAMETER_DISTANCE_"
        ),
        dataIndex: "tripdistance",
        key: "tripdistance",
        width: "10%",
      },
      {
        title: context.translate("_WAITING_TIME_"),
        dataIndex: "waitingTime",
        key: "waitingTime",
        width: "12%",
        render: (value) => this.formatDuration(value),
      },
      {
        title: context.translate("_VAT_"),
        dataIndex: "taxAmount",
        key: "taxAmount",
        width: "12%",
      },
      {
        title: context.translate("_TRIP_DURATION_"),
        dataIndex: "duration",
        key: "duration",
        width: "12%",
        render: (value) => this.formatDuration(value),
      },
      {
        title: context.translate("_BASIC_FARE_"),
        dataIndex: "basicFare",
        key: "basicFare",
        width: "12%",
      },
      {
        title: context.translate("_MIN_FARE_"),
        dataIndex: "minFare",
        key: "minFare",
        width: "12%",
      },
      {
        title: context.translate("_DISTANCE_FARE_"),
        dataIndex: "tripDistanceFare",
        key: "tripDistanceFare",
        width: "12%",
      },
      {
        title: context.translate("_WAITING_FARE_"),
        dataIndex: "tripWaitingTimeFare",
        key: "tripWaitingTimeFare",
        width: "12%",
      },
      {
        title: context.translate("_TOLL_"),
        dataIndex: "toll",
        key: "toll",
        width: "12%",
      },
      {
        title: context.translate(
          "_FLEET_DASHBORD_NEWPOI_TYPEDDL_AIRPORT_"
        ),
        dataIndex: "airport",
        key: "airport",
        width: "12%",
      },
      {
        title: context.translate("_PARKING_"),
        dataIndex: "parking",
        key: "parking",
        width: "12%",
      },
      {
        // Extra Fare
        title: context.translate("_EXTRA_FARE_"),
        dataIndex: "extraAmount",
        key: "extraAmount",
        width: "12%",
      },
      {
        title: context.translate("_TOTAL_FARE_"),
        dataIndex: "totalFare",
        key: "totalFare",
        width: "12%",
      },
    ]);
    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      selectedVehicles: [],
      selectedDrivers: [],
      selectAllVehicles: false,
      selectAllDrivers: false,
      showMonthPopup: false,
      filterby: "",
      data: "",
      companyId: "",
      fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      toDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      Notcompany: false,
      Notasset: false,
      NotDriver: false,
      expandedRowKeys: [],
      loadedInvoiceData: {},
      selectAllStatus: false,
      status: [],
      innerGridData: [],
      hasInvoice: false,
      filterValue: "",
      filterNotSelected: false,
      showInnerGrid: false,
      reportmessage: "",
      selectedColumns: widthAdderFunc([
        {
          title: context.translate("_VEHICLE_NO_"),
          dataIndex: "vehicleNo",
          key: "vehicleNo",
          width: "15%",
        },
        {
          title: context.translate("_TOTAL_NO_OF_TRIPS_"),
          dataIndex: "totalTrips",
          key: "totalTrips",
          width: "15%",
        },

        {
          title: context.translate(
            "_FLEET_CREATEROUTE_ROUTEADD_TOTALDISTANCE_"
          ),
          dataIndex: "odometer",
          key: "odometer",
          width: "15%",
        },

        {
          title: context.translate("_TOTAL_DISTANCE_FARE_"),
          dataIndex: "totalTripDistanceFare",
          key: "totalTripDistanceFare",
          width: "15%",
        },

        {
          title: context.translate("_TOTAL_WAITING_TIME_FARE_"),
          dataIndex: "totalTripWaitingTimeFare",
          key: "totalTripWaitingTimeFare",
          width: "15%",
        },

        {
          title: context.translate("_TOTAL_VAT_"),
          dataIndex: "totalTaxAmount",
          key: "totalTaxAmount",
          width: "15%",
        },
        {
          title: context.translate("_TOTAL_FARE_"),
          dataIndex: "totalFare",
          key: "totalFare",
          width: "15%",
        },
        {
          title: context.translate("_TOTAL_EXTRA_"),
          dataIndex: "totalExtraAmount",
          key: "totalExtraAmount",
          width: "15%",
        }
      ]),

      innerSelectedColumns: this.innerColumns.filter(
        (col) => !["toll", "airport", "parking", "selectedFareType", "orderChannelId"].includes(col.key)
      ),


    };
    //this.tripLogReportStore.exportExcel(getData);
    this.menuProps = {
      items: this.ExportOption,
      onClick: async (val) => {
        let result = [];
        let result2 = [];

        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));
          this.state.innerSelectedColumns.forEach((obj) =>
            result2.push(obj.dataIndex)
          );
          var getData = {
            userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
            isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles,
            filterby: this.state.filterby,
            driverId: this.state.selectedDrivers,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,

            colList: result.toString(),
            colList2: result2.toString(),
            language: null,
          };

          if (val.key == "excel") {
            await this.tripLogReportStore.exportExcel(getData);
            const isSuccess =
              this.tripLogReportStore?.pythonReportMessage === true;
            const isError = this.tripLogReportStore?.pythonReportErrorMessage;

            if (isSuccess || isError) {
              await this.setState({
                reportmessage: isSuccess ? "success" : "error",
              });
              await this.triggerReport();
            }
          }
          if (val.key == "pdf") {
            await this.tripLogReportStore.exportpdf(getData);
            const isSuccess =
              this.tripLogReportStore?.pythonReportMessage === true;
            const isError = this.tripLogReportStore?.pythonReportErrorMessage;

            if (isSuccess || isError) {
              await this.setState({
                reportmessage: isSuccess ? "success" : "error",
              });
              await this.triggerReport();
            }
          }
        }
      },
    };


    this.newColumns = [...this.state.selectedColumns];
    // this.innerColumns = [...this.state.innerSelectedColumns];

    {
      this.innerColumns.map((column) => (
        <Checkbox
          checked={this.state.innerSelectedColumns.some(
            (c) => c.key === column.key
          )}
          onChange={() => this.handleCheckboxChange(column)}
        >
          {column.title}
        </Checkbox>
      ))
    }


  }
  triggerReport = () => {
    this.pythonMessageRef.current.show(); // show the modal
  };

  async componentDidMount() {
    this.setState({ pageSize: 50 });

    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;

      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }
    await this.setState({ column: this.state.selectedColumns });
  }

  async handleChange(comp) {
    await this.setState({ Notcompany: false });
    await this.setState({ companyId: comp?.value });
    await this.setState({
      selectedVehicles: [],
      selectAllVehicles: false,
      selectedDrivers: [],
      selectAllDrivers: false,
    });

    await this.vehicleStore.getVehiclesCompanyId(comp?.value);

    await this.driverLoginStore.getDriversByCompanyId({
      companyId: comp?.value,
    });

    await this.setState({ loadData: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    // this.handleSearch();
    await this.showData();
  }

  addMonths = (date, months) => {
    // date.setMonth(date.getMonth() + months);
    // date = date + months;
    var indx = dayjs().month() + -6;
    // return date.format("YYYY-MM-DD HH:mm:ss");
    return dayjs().month(indx);
  };
  checkFromDate(dates) {
    var fromDate = dates;
    var pdate = this.addMonths();
    if (pdate > fromDate) {
      this.setState({ showMonthPopup: true });
      return false;
    } else {
      return true;
    }
  }

  onDateTimeChange = (dates) => {
    if (dates) {
      const format = "YYYY-MM-DD HH:mm:ss";
      this.setState({
        fromdateStdTime: dates[0],
        fromDate: dates[0].format(format),
        toDate: dates[1].format(format),
      });
    }
  };

  showData = async () => {
    this.setState({
      showInnerGrid: false,
      expandedRowKeys: []
    });
    if (!this.state.companyId) {
      this.setState({ Notcompany: true });
    } else {
      this.setState({ Notcompany: false });
    }
    if (this.state.selectedVehicles.length === 0) {
      this.setState({ Notasset: true });
    } else {
      this.setState({ Notasset: false });
    }
    if (this.state.selectedDrivers.length === 0) {
      this.setState({ NotDriver: true });
    } else {
      this.setState({ NotDriver: false });
    }
    if (this.state.filterValue.length === 0) {
      this.setState({ filterNotSelected: true });
    } else {
      this.setState({ filterNotSelected: false });
    }
    if (
      (this.state.companyId &&
        this.state.filterValue.length > 0 &&
        this.state.selectedDrivers.length > 0) ||
      (this.state.companyId &&
        this.state.filterValue.length > 0 &&
        this.state.selectedVehicles.length > 0)
    ) {
      this.setState({ Notcompany: false, Notasset: false, NotDriver: false });
      if (this.checkFromDate(this.state.fromdateStdTime)) {
        await this.tripLogReportStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: this.state.companyId,
          filterBy: this.state.filterby,
          vehicleId: this.state.selectedVehicles,
          driverId: this.state.selectedDrivers,
          fromDate: this.state.fromDate,
          toDate: this.state.toDate,
          pageNo: this.state.currentPage,
        });
        await this.setState({ loadData: 1 });
      }
    }
  };

  expandedRowRender = (id) => {

    const columns = this.state.innerSelectedColumns;

    return (
      <div className="innerGridTbl">
        <Table
          bordered
          size="small"
          style={{ padding: "20px 20px 20px 10px" }}
          columns={columns}
          // scroll={{ x: 50 }}
          dataSource={this.tripLogReportStore.tripData}
          pagination={false}
        />
      </div>
    );
  };

  onExpand = async (expanded, record) => {
    const expandedRowKeys = expanded ? [record.driverId] : [];
    this.setState({ expandedRowKeys });

    if (expanded) {
      await this.handleExpandRow(record);
    }
  };

  handleExpandRow = async (record) => {
    this.setState({ innerGridData: record });
    if (!this.state.loadedInvoiceData[record.driverId]) {
      await this.tripLogReportStore.loadTripLogData({
        vehicleId: record.vehicleId,
        fromDate: this.state.fromDate,
        toDate: this.state.toDate,
        companyId: this.state.companyId,
      });
      this.setState((prevState) => ({
        loadedInvoiceData: {
          ...prevState.loadedInvoiceData,
          [record.startTime]: true,
        },
      }));
    }
  };

  formatDuration = (value) => {
    const d = Number(value);

    const h = Math.floor(d / 3600);
    const m = Math.floor((d % 3600) / 60);
    const s = Math.floor(d % 60);

    const hDisplay = h > 0 ? String(h).padStart(2, "0") + ":" : "00:";
    const mDisplay = m > 0 ? String(m).padStart(2, "0") + ":" : "00:";
    const sDisplay = s > 0 ? String(s).padStart(2, "0") : "00";

    return hDisplay + mDisplay + sDisplay;
  };
  handleCheckboxChange = async (column) => {
    console.log(column);
    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );
      console.log(filtered);
      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
      // await  this.updateVisibleColumns();
    } else {
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
      // await  this.updateVisibleColumns();
    }
  };
  refreshList = async () => {
    await this.setState({ loading: false, pageNo: 1, currentPage: 1 });
    await this.showData();
  };
  handleInnerCheckboxChange = (column) => {
    const selected = [...this.state.innerSelectedColumns];

    const exists = selected.find((c) => c.key === column.key);

    if (exists) {
      const filtered = selected.filter((c) => c.key !== column.key);
      this.setState({ innerSelectedColumns: filtered });
    } else {
      this.setState({
        innerSelectedColumns: [...selected, column],
      });
    }
  };
  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  onChange={this.handleChange}
                  className="searchInput"
                  allowClear={true}
                  style={{ width: 150 }}
                  // style={companyInputStyle}
                  status={this.state.Notcompany ? "error" : false}
                />

                <Select
                  className="searchInput"
                  style={{ width: 130 }}
                  // placeholder='Filter by'
                  status={this.state.filterNotSelected ? "error" : false}
                  placeholder={this.context.translate("_FILTER_BY_")}
                  onChange={(val) => {
                    this.setState({ filterValue: val });

                    this.setState({
                      filterby: val,
                      selectedDrivers: [],
                      selectedVehicles: [],
                      selectAllDrivers: false,
                      selectAllVehicles: false,
                    });
                  }}
                >
                  <Select.Option value="Driver">
                    {this.context.translate(
                      "_FLEET_DASHBORD_HISTORY_TOOLTIP_DRIVER_"
                    )}
                  </Select.Option>

                  <Select.Option value="Vehicle">
                    {this.context.translate("_VEHICLES_")}
                  </Select.Option>
                </Select>
                {this.state.filterby == "Vehicle" && (
                  <>
                    <Select
                      className="searchInput"
                      maxTagCount="responsive"
                      value={this.state.selectedVehicles}
                      onChange={(val) => {
                        this.setState({ selectedVehicles: val });
                      }}
                      style={{ width: 180 }}
                      showSearch
                      status={this.state.Notasset ? "error" : false}
                      mode="multiple"
                      placeholder={this.context.translate(
                        "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                      )}
                      filterOption={(inputValue, option) => {
                        if (option.children) {
                          return (
                            option.children
                              .toLowerCase()
                              .indexOf(inputValue.toLowerCase()) >= 0
                          );
                        }
                      }}
                    >
                      {this.vehicleStore?.getVehiclesUsingCompanyId?.map(
                        (val) => {
                          return (
                            <Option key={val.vehicleId} value={val.vehicleId}>
                              {val.vehicleNo}
                            </Option>
                          );
                        }
                      )}
                    </Select>
                  </>
                )}
                {this.state.filterby == "Driver" && (
                  <>
                    <Select
                      className="searchInput"
                      maxTagCount="responsive"
                      value={
                        this.state.selectedDrivers
                        // ? this.state.selectedDrivers
                        // : null
                      }
                      onChange={(val) => {
                        this.setState({ selectedDrivers: val });
                      }}
                      style={{ width: 180 }}
                      showSearch
                      status={this.state.NotDriver ? "error" : false}
                      mode="multiple"
                      placeholder={this.context.translate(
                        "_FLEET_DRIVER_DRIVERLIST_DRIVERNAME_"
                      )}
                      filterOption={(inputValue, option) => {
                        if (option.children) {
                          return (
                            option.children
                              .toLowerCase()
                              .indexOf(inputValue.toLowerCase()) >= 0
                          );
                        }
                      }}
                    >
                      {this.driverLoginStore?.getDrivers?.map((val) => {
                        return (
                          <Option key={val.driverId} value={val.driverId}>
                            {val.name}
                          </Option>
                        );
                      })}
                    </Select>
                  </>
                )}

                <RangePicker
                  className="searchInput"
                  placeholder={[
                    this.context.translate("_FROM_DATE_TIME_"),
                    this.context.translate("_TO_DATETIME_"),
                  ]}
                  format="DD-MM-YYYY hh:mmA"
                  style={{ width: 400, borderRadius: "25px" }}
                  onChange={(val) => {
                    this.onDateTimeChange(val);
                  }}
                  // disabledDate={(current) => {
                  //   return current && current > dayjs();
                  // }}
                  showTime={{
                    format: "h:mmA",
                    defaultValue: [dayjs().startOf("day"), dayjs()],
                  }}
                  defaultValue={[dayjs().startOf("day"), dayjs()]}
                />

                <Button type="primary" onClick={() => this.showData()}>
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                </Button>

                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {this.context.translate("_COLUMNS_")}
                </Button>
              </Space>
            </Col>
            <Col span={4}>
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              ></Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={4}
            >
              <Space>
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>
                <Button
                  className="downloadExcelButton"
                  disabled={
                    this.tripLogReportStore?.tripLogReportData?.length > 0
                      ? false
                      : true
                  }
                >
                  <Dropdown
                    overlayClassName="export-dropdown"
                    menu={this.menuProps}
                  >
                    <Image
                      style={{
                        height: 18,
                        alignItems: "center",
                        marginInlineEnd: "30px",
                      }}
                      src={downloadIcon}
                    ></Image>
                  </Dropdown>
                </Button>
              </Space>
            </Col>
          </Row>

          <ListTable
            rowKey="driverId"
            expandable={{
              expandedRowRender: this.expandedRowRender,
              onExpand: this.onExpand,
              expandedRowKeys: this.state.expandedRowKeys,
            }}
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.tripLogReportStore?.total}
            columns={this.state.column}
            dataSource={this.tripLogReportStore?.tripLogReportData}
            loading={this.tripLogReportStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>
        <Modal
          open={this.state.modalVisible}
          width={300}
          title={this.context.translate("_SELECT_COLUMNS_")}
          onCancel={() => this.setState({ modalVisible: false })}
          footer={null}
        >
          <div style={{ maxHeight: "400px", overflowY: "auto" }}>

            {/* MAIN GRID */}
            <p style={{ fontWeight: "bold" }}>Main Grid Columns</p>

            {this.newColumns.map((column, v) => {
              return (
                <Row key={v}>
                  <Col>
                    <Checkbox
                      onChange={() => this.handleCheckboxChange(column)}
                      checked={this.state.selectedColumns.some(
                        (c) => c.key === column.key
                      )}
                    >
                      {column.title}
                    </Checkbox>
                  </Col>
                </Row>
              );
            })}

            <Divider />

            {/* INNER GRID */}
            <p style={{ fontWeight: "bold" }}>Inner Grid Columns</p>

            {this.innerColumns.map((column, v) => {
              return (
                <Row key={v}>
                  <Col>
                    <Checkbox
                      onChange={() => this.handleInnerCheckboxChange(column)}
                      checked={this.state.innerSelectedColumns.some(
                        (c) => c.key === column.key
                      )}
                    >
                      {column.title}
                    </Checkbox>
                  </Col>
                </Row>
              );
            })}
          </div>
        </Modal>
        <Modal
          width={350}
          className="alert-model"
          title={
            <div>
              {" "}
              <i
                style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                class="bi bi-exclamation-triangle"
              ></i>{" "}
              {this.context.translate("_FLEET_ALERT_")}
            </div>
          }
          open={this.state.showMonthPopup}
          onOk={() => this.setState({ showMonthPopup: false })}
          onCancel={() => this.setState({ showMonthPopup: false })}
          footer={false}
        >
          {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
        </Modal>
        {
          <div>
            <PythonMessageAlert
              ref={this.pythonMessageRef}
              message={this.state.reportmessage}
            />
          </div>
        }
      </>
    );
  }
}
TripLogReport.contextType = StoreContext;
export default observer(withRouter(TripLogReport));
